(() => {
  'use strict';

  const root = document.documentElement;
  if (!root.classList.contains('meller-klaviyo-gated')) return;

  let timer;

  const releasePopup = () => {
    root.classList.remove('meller-klaviyo-gated');
    window.removeEventListener('scroll', handleScroll);
    window.clearTimeout(timer);
  };

  const handleScroll = () => {
    const releaseAt = Math.min(600, Math.max(360, window.innerHeight * 0.65));
    if (window.scrollY >= releaseAt) releasePopup();
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  timer = window.setTimeout(releasePopup, 20000);
})();
